import { type ReactElement, type ReactNode } from 'react';
import { GlobalConfig as GlobalConfigBase, type ICloudinaryConfig } from '@cars4ever/public-ui';
import { useBrandTheme, type BrandCode } from '@cars4ever/brand-config-core';

import WidgetLayoutProvider from '^common/WidgetLayoutProvider';
import ErrorBoundary from '^common/ErrorBoundary';
import { CLOUD_NAME } from '^configs/environments';
import Logger from '^utils/logger';

export interface IGlobalConfigProps {
  children: ReactNode;
  brandConfig?: any;
}

const handleCloudinaryImageError = (src: string): void => {
  Logger.trackWarning(`Image (${src}) is not found`, {
    catcher: 'OptimizedImage.error',
  });
};

const cloudinaryConfig: ICloudinaryConfig = {
  cloudName: CLOUD_NAME,
  handleError: handleCloudinaryImageError,
};

const GlobalConfig = ({ children }: IGlobalConfigProps): ReactElement => {
  const brandTheme = window.xprops.theme as BrandCode;

  // Apply brand theme (hook handles the case when config isn't loaded yet)
  useBrandTheme(brandTheme);

  return (
    <GlobalConfigBase
      cloudinaryConfig={cloudinaryConfig}
    >
      <ErrorBoundary>
        <WidgetLayoutProvider>
          {children}
        </WidgetLayoutProvider>
      </ErrorBoundary>
    </GlobalConfigBase>
  );
};

export default GlobalConfig;
